module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/photoalbums/bravenet_photo_albums_private_and_public_albums.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/photoalbums/bravenet_photo_albums_private_and_public_albums.png
// module id = uryf
// module chunks = 0